import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { CloseIcon } from "../../assets/Icons";
import LoaderWhite from "../../components/LoaderWhite";
import { useOpenAiUrlSummaryMutation } from "../../store/services/openAiService";
import {
  setFormInfo,
  setInputDataDetail,
} from "../../store/reducers/globalReducer";

const GenerateUrlSummaryModel = ({ setOpenGenerateUrl, modelData }) => {
  const { item, index } = modelData;

  const dispatch = useDispatch();
  const { formInfo, inputDataDetail } = useSelector(
    (state) => state.globalReducer
  );
  const { userId } = useSelector((state) => state.authReducer);

  const [url, setURL] = useState(item?.["Final URL"]);
  const [completionRequest, data] = useOpenAiUrlSummaryMutation();

  let urlRes = { ...data };

  const submitUrlSummary = () => {
    completionRequest({
      userId: userId,
      landing_page_url: url,
    });
  };

  const initialValues = {
    url: item?.["Final URL"],
    userId,
  };
  const validate = (values) => {
    const errors = {};
    const url = values.url.trim();

    if (!url) {
      errors.url = "URL is required";
    } else if (!/^https?:\/\//i.test(values.url)) {
      errors.url = "Please add http:// or https:// before your url";
    }
    return errors;
  };

  const formik = useFormik({
    initialValues,
    validate,
    onSubmit: (values) => {
      completionRequest({
        userId: userId,
        landing_page_url: values.url,
      });
    },
  });
  const myObject = inputDataDetail.find((item) => item.index === index);
  const [desc, setDesc] = useState(
    urlRes?.data?.response[0]?.value?.completion?.text
      ? urlRes?.data?.response[0]?.value?.completion?.text
      : myObject?.urlDesc
  );

  useEffect(() => {
    if (data.isSuccess) {
      let textVal = urlRes?.data?.response[0]?.value?.completion?.text;
      setDesc(textVal.trim());
      const location = inputDataDetail.findIndex((obj) => obj.index === index);
      const myObject = inputDataDetail.find((item) => item.index === index);
      if (index !== 92)
        if (location === -1) {
          dispatch(
            setInputDataDetail([
              ...inputDataDetail,
              {
                index,
                pName: myObject ? myObject?.pName : "",
                pDesc: textVal.trim(),
                urlDesc: textVal.trim(),
              },
            ])
          );
        } else {
          dispatch(
            setInputDataDetail([
              ...inputDataDetail.slice(0, location),
              {
                index,
                pName: myObject ? myObject?.pName : "",
                pDesc: textVal.trim(),
                urlDesc: textVal.trim(),
              },
              ...inputDataDetail.slice(location + 1),
            ])
          );
        }
      else {
        dispatch(
          setFormInfo({
            ...formInfo,
            pName: "",
            pDesc: textVal.trim(),
            urlDesc: textVal.trim(),
          })
        );
      }
    }
  }, [data.isSuccess]);

  return (
    <div className="generate-url-summary flex">
      <div className="generate-url-summary-block flex flex-col">
        <div className="block-hdr flex items-center justify-end">
          <div
            className="icon flex items-center justify-center cursor-pointer"
            onClick={(e) => setOpenGenerateUrl(false)}
          >
            <CloseIcon />
          </div>
        </div>
        {data.isLoading ? (
          <LoaderWhite />
        ) : (
          <>
            <form onSubmit={formik.handleSubmit}>
              <div className="field flex flex-col">
                <label className="lbl" htmlFor="url">
                  URL
                </label>
                <input
                  id="url"
                  name="url"
                  type="text"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.url}
                  className="min-h-[30px] txt-area"
                  placeholder="https://example.com"
                />
                {formik.touched.url && formik.errors.url ? (
                  <div className="text-white p-2 text-sm font-medium">
                    {formik.errors.url}
                  </div>
                ) : null}
                <button className="btn button" type="submit">
                  Generate Summary
                </button>
              </div>

              {/* <div className="field flex flex-col">
                  <div className="lbl">URL</div>
                  <input
                    className="min-h-[30px] txt-area"
                    value={url}
                    onChange={(e) => setURL(e.target.value)}
                  />
                  <button
                    className="btn button"
                    onClick={(e) => submitUrlSummary()}
                  >
                    Generate Summary
                  </button>
                </div> */}
            </form>
            <div className="field flex flex-col mt-10">
              <div className="lbl">Landing Page Summary</div>
              <textarea
                className="min-h-[140px] txt-area"
                value={desc}
                onChange={(e) => setDesc(e.target.value)}
              />
              <CopyToClipboard text={`${desc}`}>
                <button
                  className="btn button"
                  onClick={(e) => setOpenGenerateUrl(false)}
                >
                  Copy To Clipboard
                </button>
              </CopyToClipboard>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default GenerateUrlSummaryModel;
